// extracted by mini-css-extract-plugin
export default {"imageContainer":"examImage_imageContainer__eiZFw","questionImage":"examImage_questionImage__eTNS9"};